import axios from 'axios'

import { convertEncryptedToPlantext, convertPlantextToEncrypted } from '../encrypt-decrypt'

export const refreshAccessToken = async (refreshToken: string) => {
  try {
    // Encrypt the refresh token payload
    const encryptedPayload = convertPlantextToEncrypted({
      refresh_token: refreshToken
    })

    // Make the refresh token API call using axios.post
    const response = await axios.post(
      `${process.env.NEXT_PUBLIC_API_URL}auth/refresh-token`, // Full URL
      encryptedPayload, // Encrypted payload
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': 'en'
        }
      }
    )

    // ✅ Check for 203 and handle token expiration
    if (response.status === 203) {
      console.warn('Refresh token expired, forcing logout')

      return { error: 'RefreshTokenExpired' } // Mark for logout
    }

    // Decrypt the response
    const refreshedTokens = convertEncryptedToPlantext(response.data.data)

    // Return the new tokens
    return {
      access_token: refreshedTokens.data.access_token,
      refresh_token: refreshedTokens.data.refresh_token,
      expires_at: refreshedTokens.data.access_token_expiry * 1000
    }
  } catch (error: any) {
    // Decrypt the error response (if available)
    const decryptedError = convertEncryptedToPlantext(error?.response?.data?.data)

    return { error: decryptedError }
  }
}
